/* Nibby: Before & afters — previous/next buttons for the scroll-snap track (swipe works natively). */
(function () {
  if (customElements.get('nibby-ba-carousel')) return;

  class NibbyBaCarousel extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.nibby-ba');
      this.track = this.querySelector('[data-ba-track]');
      if (!this.section || !this.track) return;
      this.prev = this.section.querySelector('[data-ba-prev]');
      this.next = this.section.querySelector('[data-ba-next]');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onPrev = () => this.go(-1);
      this.onNext = () => this.go(1);
      this.onScroll = () => this.update();
      if (this.prev) this.prev.addEventListener('click', this.onPrev);
      if (this.next) this.next.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.update();
    }

    disconnectedCallback() {
      if (this.prev) this.prev.removeEventListener('click', this.onPrev);
      if (this.next) this.next.removeEventListener('click', this.onNext);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    step() {
      const card = this.track.firstElementChild;
      if (!card) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    go(direction) {
      this.track.scrollBy({
        left: direction * this.step(),
        behavior: this.reduceMotion ? 'auto' : 'smooth',
      });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      this.section.classList.toggle('nibby-ba--static', max <= 0);
    }
  }

  customElements.define('nibby-ba-carousel', NibbyBaCarousel);
})();
